import { createContext, useContext, useMemo } from 'react'
import { request } from './graphql'
// import GLOBALS_QUERY from '../graphql/queries/globals'
// import availableLocales from '../translation/locales'

const GLOBALS_QUERY = null
const availableLocales = null

export const GlobalsContext = createContext( null )
GlobalsContext.displayName = 'GlobalsContext'

export const useGlobals = () => useContext( GlobalsContext )

export const withGlobals = PageComponent => {
  function WithGlobals( pageProps ) {
    return (
      <GlobalsProvider
      // eslint-disable-next-line react/destructuring-assignment
        globals={ pageProps.globals }
      // eslint-disable-next-line react/destructuring-assignment
        req={ pageProps.req }
      >
        { /* eslint-disable-next-line react/jsx-props-no-spreading */ }
        <PageComponent { ...pageProps } />
      </GlobalsProvider>
    )
  }

  return WithGlobals
}

export const loadGlobals = async locale => {
  const locales = availableLocales?.map( l => l.code ).includes( locale )
    ? [locale]
    : ['en']

  const response = GLOBALS_QUERY
    ? await request( GLOBALS_QUERY, { site: locales } )
    : null

  return response?.data || {}
}

export function GlobalsProvider( { globals, req, children } ) {
  return (
    <GlobalsContext.Provider value={ useMemo( () => ( { ...globals, req } ), [globals, req] ) }>
      { children }
    </GlobalsContext.Provider>
  )
}
